<template>
  <div class="operation" v-if="operation">
    <Breadcrumbs :items="breadcrumbs">
        <router-link :to="{ name: 'edit-operation', params: { id: this.$route.params.id, operation: this.operation}}">
          <rp-sprite class="create-icon" name="create"/>
        </router-link>
      <rp-sprite @click.native="activeConfirm = !activeConfirm" class="create-icon" name="delete_outline"/>
    </Breadcrumbs>

    <div class="content">
      <div class="patient-operation-section">
        <div v-if="!operation.patient.profile" class="patient-info">
          <div class="info-group">
            <p>Patient has been deleted.</p>
          </div>
        </div>
        <div v-else class="patient-info">
          <!-- <div class="info-group">
            <h3>Operation ID</h3>
            <p>{{operation.patient_ref ? operation.patient_ref : 'NOT PROVIDED'}}</p>
          </div> -->
          <div class="info-group">
            <h3>Email Address</h3>
            <p>{{operation.patient.email === 'n/a' ? 'PATIENT DELETED' : operation.patient.email}}</p>
          </div>
          <div class="info-group">
            <h3>First Name</h3>
            <p>{{getProfileProp('first_name')}}</p>
          </div>
          <div class="info-group">
            <h3>Last Name</h3>
            <p>{{getProfileProp('last_name')}}</p>
          </div>
          <div class="info-group">
            <h3>Gender</h3>
            <p>{{getProfileProp('gender') | genderFilter}}</p>
          </div>
          <div class="info-group">
            <h3>Year of birth</h3>
            <p>{{getProfileProp('yob')}}</p>
          </div>
        </div>

        <hr />

        <div class="operation-info">
          <div class="info-group">
            <h3>Surgery Date</h3>
            <p>{{new Date(operation.performed_at).toLocaleDateString()}}</p>
          </div>
          <div class="info-group">
            <h3>Hospital</h3>
            <p>{{operation.hospital.name}}</p>
          </div>
          <div class="operated-eyes" v-for="eye in operation.operation_iols" :key="eye.ey">
            <div class="info-group">
              <h3>Operated eye</h3>
              <p>{{eye.eye | eyeFilter}}</p>
            </div>
            <div class="info-group">
              <h3>IOL manufacturer</h3>
              <p>{{(eye.iol) ? eye.iol.manufacturer : eye.custom_iol.manufacturer}}</p>
            </div>
            <div class="info-group">
              <h3>IOL model</h3>
              <p>{{(eye.iol) ? eye.iol.model : eye.custom_iol.model}}</p>
            </div>
            <div class="info-group">
              <h3>IOL power</h3>
              <p v-for="eye in eye.power" :key="eye.power">{{eye}}</p>
            </div>
          </div>
          <div class="info-group">
            <h3>Monovision</h3>
            <p>{{operation.blended_vision ? 'Yes' : 'No'}}</p>
          </div>
          <div class="info-group">
            <h3>Complex surgery</h3>
            <p>{{operation.complex_surgery ? 'Yes' : 'No'}}</p>
          </div>
          <div class="info-group">
            <h3>Patient provided with AEON Repair eye drops</h3>
            <p>{{operation.aeon_drops_provided ? 'Yes' : 'No'}}</p>
          </div>
        </div>
      </div>

      <!-- OPERATION NOTES SECTION -->

      <!-- <div class="operation-notes">
        <div class="notes-title">Operation notes</div>
        <div class="no-notes" v-if="notes && notes.length < 1">
          <p class="note">There are no notes</p>
        </div>
        <div v-else class="note-section" v-for="note in notes" :key="note.id">
          <p class="note">
            {{note.body_md}}
          </p>
          <div class="button-group">
            <rp-button type="primary">Edit</rp-button>
            <rp-button type="danger" @click.native="startNoteDelition(note)">Delete</rp-button>
          </div>
        </div>
        <rp-button @click.native="addNote = !addNote">Add note</rp-button>
      </div> -->

      <rp-overlay :active="activeConfirm">
        <rp-delete-confirm
          icon="warning"
          userType="surgery"
          messageType='Delete'
          :cancel="cancelDeletion"
          :confirm="confirmDeletion"/>
      </rp-overlay>

      <rp-overlay :active="activeDelete">
        <rp-alert
          icon="done"
          :message="alertMessage"
          :onClick="alertFunct"/>
      </rp-overlay>
      <!-- ADD NOTES MODAL AND ALERT/DELETE COMPONENTS -->

      <!-- <rp-modal :show="addNote" :onClose="closeModal" :closeIcon="true">
        <div class="modal-header">Add note</div>
        <div class="modal-body">
          <rp-add-note 
            @submit="createNote"
            :cancelClick="closeModal"
            v-model="form"
          />
        </div>
      </rp-modal>
      <rp-overlay :active="activeNote">
        <rp-alert
          icon="done"
          :message="alertNoteMessage"
          :onClick="alertNoteFunct"/>
      </rp-overlay>
      <rp-overlay :active="activeNoteConfirm">
        <rp-delete-confirm
          icon="warning"
          messageText="Are you sure you wish to delete this note"
          :cancel="cancelNoteDeletion"
          :confirm="removeNote"/>
      </rp-overlay>
      <rp-overlay :active="activeNoteDeleted">
        <rp-alert
          icon="done"
          :message="alertNoteDeletedMessage"
          :onClick="alertNoteDeleteFunct"/>
      </rp-overlay> -->
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import UserDeleteModal from '@/components/UserDeleteModal'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import DeleteConfirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Button from 'raypro_ui/src/components/ui/inputs/Button'

// ADD NOTE AND MODAL COMPONENTS IMPORTED FROM UI
// import AddNote from 'raypro_ui/src/components/ui/forms/AddNote'
// import Modal from '@/components/Modal'

import page from '@/mixins/page'


// API
import {getOperationById, deleteOperation} from 'raypro_ui/src/api/operations'

export default {
  components: {
    Breadcrumbs,
    UserDeleteModal,
    RpSprite,
    // 'rp-add-note': AddNote, ADD NOTE COMPONENT
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-delete-confirm': DeleteConfirm,
    // 'rp-modal': Modal, MODAL COMPONENT
    'rp-button': Button
  },

  mixins: [page],

  data() {
    return {
      operation: null,
      activeConfirm: false,
      activeDelete: false,
      addNote: false,
      activeNote: false,
      activeNoteConfirm: false,
      activeNoteDeleted: false,
      title: 'Surgery',
      id: ''

      // DATA FOR NOTES

      // form: {},
      // notes: null,
      // patientId: null,
      // noteToDelete: null
    }
  },

  filters: {
    eyeFilter(eye) {
      return eye === 'L' ? 'Left' : 'Right'
    },
    genderFilter(gender) {
      if(gender === 'PATIENT DELETED') {
        return gender
      }
      if(gender === 'M') {
        return 'Male'
      }
      if(gender === 'F') {
        return 'Female'
      }
      if(gender === 'O') {
        return 'Prefer not to say'
      }

      return 'NOT PROVIDED'
    }
  },

  mounted() {
    this.id = this.$route.params.id

    this.getOperationData(this.id)
  },

  watch: {
    '$route.params.id'() {
      this.id = this.$route.params.id
      this.getOperationData(this.id)
    }
  },

  computed: {
    // notePayload() {
    //   const form = this.form

    //   return {
    //     note: {
    //       'operation_id': this.operation.id,
    //       'body_md': form.message
    //     }
    //   }
    // },

    alertMessage() {
      return 'Surgery deleted successfully!'
    },

    // alertNoteMessage() {
    //   return 'Note added successfully!'
    // },

    // alertNoteDeletedMessage() {
    //   return 'Note deleted successfully!'
    // },

    breadcrumbs() {
      return [
        {
          label: 'Surgeries',
          link: 'all-operations'
        },
        {label: this.getFullName(this.operation.patient)}
      ]
    }
  },

  methods: {
    // closeModal() {
    //   this.addNote = false
    //   this.form.message = ''
    // },

    getOperationData(id) {
      getOperationById({id}).then(({data}) => {
        this.operation = data

        // METHOD FOR DISPLAYING NOTES
        // getUserNotes(this.operation.patient.id).then(({data}) => {
        //   this.notes = data
        // })
      })
    },

    alertFunct() {
      this.$router.push({name: 'all-operations'})
    },
    getFullName(data) {
      const profile = data.profile
      let name = ''

      if(profile) {
        if(!profile.first_name && !profile.last_name) {
          return 'NOT PROVIDED'
        }
        if(profile.first_name) {
          name += `${profile.first_name}`
        }
        if(profile.last_name) {
          name += ` ${profile.last_name}`
        }
        return name
      }
      return 'PATIENT DELETED'
    },
    getProfileProp(prop) {
      const profile = this.operation.patient.profile

      if(profile) {
        if(profile[prop]) {
          return profile[prop]
        }
        if(!profile[prop]) {
          return 'NOT PROVIDED'
        }
      }
      return 'PATIENT DELETED'
    },

    // alertNoteFunct() {
    //   this.activeNote = !this.activeNote
    //   this.form.message = ''
    // },

    // alertNoteDeleteFunct() {
    //   this.activeNoteDeleted = !this.activeNoteDeleted
    // },

    // startNoteDelition(note) {
    //   this.noteToDelete = note
    //   this.activeNoteConfirm = !this.activeNoteConfirm
    // },

    // cancelNoteDeletion() {
    //   this.activeNoteConfirm = !this.activeNoteConfirm
    // },

    cancelDeletion() {
      this.activeConfirm = !this.activeConfirm
    },

    confirmDeletion() {
      const id = this.$route.params.id

      deleteOperation({id})
        .then(() => {
          this.activeConfirm = !this.activeConfirm
          this.activeDelete = !this.activeDelete
        })
        .catch(() => {
          // console.log('Not deleting')
        })
    },

    // createNote() {
    //   const USERID = this.operation.patient.id

    //   addNote(USERID, this.notePayload)
    //     .then(() => {
    //       getUserNotes(this.operation.patient.id).then(({data}) => {
    //         this.notes = data
    //       })
    //       this.activeNote = !this.activeNote
    //       this.addNote = !this.addNote
    //     })
    //     .catch(({response}) => {
    //       // TODO: map errors to flat structure for form
    //       this.errors = response.errors
    //     })
    // },

    // removeNote() {
    //   const USERID = this.operation.patient.id
    //   const NOTEID = this.noteToDelete.id

    //   deleteNote(USERID, NOTEID)
    //     .then(() => {
    //       this.cancelNoteDeletion()
    //       this.activeNoteDeleted = !this.activeNoteDeleted
    //       getUserNotes(this.operation.patient.id).then(({data}) => {
    //         this.notes = data
    //       })
    //     })
    //     .catch(({response}) => {
    //       this.errors = response.error
    //     })
    // }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.operation
  .content
    display: flex
    flex-direction: column
    @include media($media-medium)
      padding: 0 40px
      flex-direction: row
      justify-content: space-between
    .patient-operation-section
      @include media($media-medium)
        margin-right: 2rem
        flex-basis: 40%
    .info-group
      display: flex
      flex-direction: column
      @include media($media-medium)
        flex-direction: row
        align-items: center
      h3
        display: inline-flex
        width: 150px
        min-width: 150px
        margin: 0
        text-transform: initial
        font-weight: lighter
      p
        display: inline-flex
        line-height: 1
        font-weight: $font-bold
        word-break: break-word
        @include media($media-medium)
          margin-left: 1rem
    hr
      margin: 20px 0
      border-top: 1px solid $color-grey-dark
    .operation-notes
      @include media($media-medium)
        flex-basis: 65%
      .notes-title
        font-size: 16px
        font-weight: $font-bold
      .note-section
        padding-bottom: 15px
        .note
          font-size: 14px
        .button-group
          display: flex
          button
            margin-top: 0
            & + button
              margin-left: 1rem
        & + .note-section
          border-top: 1px solid $color-grey-dark

  .modal-header
    padding: 20px
    font-size: 20px
    border-bottom: 2px solid #e2e4e4

  .modal-body
    min-height: 300px
    padding: 20px

</style>



// WEBPACK FOOTER //
// src/components/pages/Operations/Operation.vue